import { render } from "./Index.vue?vue&type=template&id=5e7337c8"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=5e7337c8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/home/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e7337c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e7337c8', __exports__)) {
    api.reload('5e7337c8', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=5e7337c8", () => {
    api.rerender('5e7337c8', render)
  })

}


export default __exports__